import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { wizard, meta } from 'helpers/decorators'
import { Contact } from 'components/forms'
import { Button, FormDebug, Note } from 'components/misc'
import { apiCodeLists, apiConfiguration, apiLeaders } from 'helpers/decorators/api'
import validate from './contacts-details.validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  if (!get(values, 'email')) {
    return new Promise(resolve => resolve())
  }

  return props.checkEmail({ email: get(values, 'email') }).then(body => {
    if (get(body, 'value')) {
      // eslint-disable-next-line
      throw {
        email: {
          text: 'E-mail address is already in use.',
          intlKey: 'errors.email_address_is_in_use'
        }
      }
    }
  })
}

@apiConfiguration()
@apiCodeLists(['phoneTypes'], {
  public: true
})
@apiLeaders()
@wizard({
  form: 'leaderRegistration',
  multipage: true,
  validate,
  destroyOnUnmount: false,
  asyncValidate,
  asyncBlurFields: ['email']
})
@meta({
  title: 'Contact details',
  intlKey: 'wizard.contact_details'
})
class ContactDetails extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    values: PropTypes.object,
    isConfigurationTrue: PropTypes.func.isRequired
  }

  render() {
    const { handleSubmit, onSubmit, values, codeLists } = this.props
    const selectedCountryIcoCode = get(
      values,
      'helpers.selectedCountry.isoCode'
    )

    const showSecondaryEmail = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactEmailAddress2.id)

    const showPhoneNumber = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactPhoneNumber.id)

    return (
      <form onSubmit={handleSubmit(onSubmit)}>

        <Note hideNodePrefix={true} margin="0 0 10px 0">
          <FormattedMessage
            id="label.sharing_award_leader_info_to_participant"
            defaultMessage="Please note, that this information will be shared with participants assigned to the Award Leader."
          />
        </Note>
        <br />

        <Contact
          phoneTypes={codeLists.phoneTypes.list}
          selectedCountryIcoCode={selectedCountryIcoCode}
          showSecondaryFields
          showSecondaryEmail={showSecondaryEmail}
          showPhoneNumber={showPhoneNumber}
          showPhoneType
          showSecondaryPhone={false}
          showSecondaryPhoneType={false}
        />
        <FormDebug values={values} />
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
    )
  }
}

export default ContactDetails
